import { useQuery } from '@tanstack/react-query';

import { ShortUrl } from '@air/api';
import { useShortIdContext } from '@air/provider-short-id';

import { getPublicCustomFieldsKey } from '~/constants/react-query-keys';

export const useContentCollectionCustomFields = () => {
  const { shortId } = useShortIdContext();

  return useQuery({
    queryKey: getPublicCustomFieldsKey(shortId),
    queryFn: () => ShortUrl.listCustomFields(shortId, { limit: 100 }),
  });
};
